var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscovericon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9997 47.6668C14.0332 47.6668 4.33301 37.9667 4.33301 26.0002C4.33301 14.0337 14.0332 4.3335 25.9997 4.3335C37.9662 4.3335 47.6663 14.0337 47.6663 26.0002C47.6663 37.9667 37.9662 47.6668 25.9997 47.6668ZM22.975 22.9755L16.5682 35.4317L29.0265 29.0248L35.4312 16.5687L22.9728 22.9755H22.975Z",
    fill: "#699BF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscovericon);
export default __webpack_public_path__ + "static/media/discover icon.257dffe124ac52d47a273104208f8046.svg";
export { ForwardRef as ReactComponent };